import Cookies from "js-cookie";
var WEBVIEW_COOKIE = "client";
var isNativeClient = function (value) {
    return value === "iphone" ||
        value === "ipad" ||
        value === "android" ||
        value === "outdated_app";
};
export var createServerWebview = function (_a) {
    var cookies = _a.cookies, query = _a.query, setCookie = _a.setCookie;
    if (isNativeClient(cookies.client)) {
        return {
            isWebview: true,
            client: cookies.client,
        };
    }
    else if (isNativeClient(query.client)) {
        setCookie("client", query.client);
        return {
            isWebview: true,
            client: query.client,
        };
    }
    return {
        isWebview: false,
    };
};
export var createBrowserWebview = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.cookies, cookies = _c === void 0 ? Cookies.get() : _c, searchParams = _b.searchParams, _d = _b.setCookie, setCookie = _d === void 0 ? function (client) {
        Cookies.set("client", client);
    } : _d;
    var clientCookie = cookies[WEBVIEW_COOKIE];
    var clientUrlString = searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("client");
    if (isNativeClient(clientCookie)) {
        return {
            isWebview: true,
            client: clientCookie,
        };
    }
    else if (isNativeClient(clientUrlString)) {
        setCookie(clientUrlString);
        return {
            isWebview: true,
            client: clientUrlString,
        };
    }
    return {
        isWebview: false,
    };
};
//# sourceMappingURL=webview.js.map